import React from "react";
import Base from 'next/link';
export const Link = React.forwardRef(
    ({ block, to, href, url, children, ...props }, ref) =>
  (<Base {...{...props, ref, href: to || href || url ||  '/' }} >{children}</Base>))
export default Link;



